import React from 'react';

const NoMatch: React.FunctionComponent = () => (
  <div>No Match</div>
);

export default NoMatch;
